import { WebStorageStateStore } from "oidc-client-ts"
import { AuthProvider, AuthProviderProps, useAuth } from "react-oidc-context"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { CompanyFeatures } from "./common/store"
import useAppDispatch from "./hooks/useAppDispatch"
import useAppSelector from "./hooks/useAppSelector"
import Middleware from "./Middleware"
import { selectConfig, setCompanyFeatures, setDevelopment, setHostedDomain, setPublishConfig, setShowACECard } from "./redux/slices/config"

export default function () {
    const dispatch = useAppDispatch()
    dispatch(setPublishConfig(false))
    dispatch(setShowACECard(false))
    const releaseMode = useAppSelector(selectConfig)
    const hartmannDev = true;

    const companyFeatures: CompanyFeatures = { allowedLocalLicensePayment: false, oem: "Hartmann", language: "en-US", timezone: "America/Detroit",
     allowedOdyssey: false, allowedInvoice: false, allowedLicenseCard: false, 
        allowedHostedLicenseCard: false, allowedHostedPayment: false, allowedCameraLicensing: false, allowPayBeforeActivate: false, onHold: false,isDistributionDealer: false,allowPaymentForAddOnFeatures: false
}
    dispatch(setCompanyFeatures(companyFeatures))

    let portalURL: string = releaseMode ? companyFeatures.oem == "Aiphone" ? "https://portal.acnio-license.aiphone.com" : "https://portal.hartmann-controls.com" : "https://localhost:44410"
    let authURL: string = releaseMode ? companyFeatures.oem == "Aiphone" ? "https://auth.acnio-license.aiphone.com" : "https://auth.hartmann-controls.com" : "https://localhost:7113"

    if (hartmannDev) {
        portalURL = "https://portal.cloud.dev.hc-dev.net/"
        authURL = "https://auth.cloud.dev.hc-dev.net/"
        dispatch(setHostedDomain(".securemybuilding.com"))
    }

    // Strip any trailing slash so template-literal URLs below don't produce a double slash
    // (e.g. `${authURL}/.well-known/...` -> `...net//.well-known/...`), which breaks the OIDC
    // discovery/callback and causes a recursive sign-in redirect loop.
    portalURL = portalURL.replace(/\/+$/, "")
    authURL = authURL.replace(/\/+$/, "")

    const logo = document.querySelector(".tab-icon");
    logo!.setAttribute("href", `/${companyFeatures.oem}-icon.png`);

    const oidcConfig: AuthProviderProps = {
        authority: authURL,
        client_id: "react-app",
        client_secret: "react-app-secret",
        redirect_uri: `${portalURL}/callback`,
        post_logout_redirect_uri: `${portalURL}/callback`,
        response_type: "code",
        scope: "profile openid api roles",
        metadataUrl: `${authURL}/.well-known/openid-configuration`,
        userStore: new WebStorageStateStore({ store: window.localStorage })
    };

    return (
        <AuthProvider {...oidcConfig}>
            <BrowserRouter>
                <Middleware />
            </BrowserRouter>
        </AuthProvider>
    )
}